var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-center cursor-pointer",on:{"click":function($event){return _vm.logout()}}},[_c('h3',{staticClass:"mb-0 mr-1"},[_vm._v("Sair")]),_c('feather-icon',{attrs:{"icon":"LogInIcon","size":"24"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }